import {StorageManager, StorageSetOptions} from 'common/contexts/storage-manager/types';
import {LocalStorageKey} from 'common/report/constants';
import {UserLocalStorageHelper} from 'common/report/user-local-storage';
import {userCookieUtils} from 'common/report/util/user-identity-from-cookie';

export class LocalStorageHelper<T> extends UserLocalStorageHelper<T> {
  private userId: number;

  constructor({namespace, ttlMs, context}: {namespace: LocalStorageKey; ttlMs?: number; context: StorageManager}) {
    super({namespace, ttlMs, context});
    this.userId = userCookieUtils.getUserIdentityFromCookie()?.id;
  }

  public set(key: ObjKey, value: T, options?: StorageSetOptions): Promise<boolean> | boolean {
    return super.setItem({userId: this.userId, key, value, options});
  }

  public get(key): T | null {
    return super.getItem({userId: this.userId, key});
  }

  public remove(key): void {
    return super.removeItem({userId: this.userId, key});
  }
}
